import script from "./editCam.vue?vue&type=script&lang=ts&setup=true"
export * from "./editCam.vue?vue&type=script&lang=ts&setup=true"

import "./editCam.vue?vue&type=style&index=0&id=2b4768e0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4768e0"]])

export default __exports__